import React from 'react';
import './LoadingSkeleton.css';

const LoadingSkeleton = ({ variant = 'card', count = 1, height = 'auto' }) => {
  const renderSkeleton = () => {
    switch (variant) {
      case 'card':
        return (
          <div className="skeleton-card">
            <div className="skeleton-image" />
            <div className="skeleton-content">
              <div className="skeleton-line skeleton-title" />
              <div className="skeleton-line skeleton-text" />
              <div className="skeleton-line skeleton-text short" />
            </div>
          </div>
        );
      
      case 'text':
        return <div className="skeleton-line" style={{ height }} />;
      
      case 'circle':
        return <div className="skeleton-circle" style={{ width: height, height }} />;
      
      case 'story':
        return (
          <div className="skeleton-story-card">
            <div className="skeleton-story-image" />
            <div className="skeleton-story-content">
              <div className="skeleton-line skeleton-story-title" />
              <div className="skeleton-line skeleton-story-meta" />
            </div>
          </div>
        );
      
      default:
        return <div className="skeleton-line" />;
    }
  };

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>{renderSkeleton()}</React.Fragment>
      ))}
    </>
  );
};

export default LoadingSkeleton;
